$('#login-form').asyncForm(function (err) {
    if (err) {
        const $err = $(this).find('.error-msg')
        $err.text(err);
        return;
    }
    window.location = window.basepath + '/de_DE/settings';
});
